import type { InferGetServerSidePropsType, NextPage } from 'next';

import { Search } from '#components/Search/Search';
import type { CacheTag } from '#cutils/page-context/edge-cache-tags';
import { createDefaultGetServerSideProps } from '#cutils/page-context/server-side-props';
import { buildContentPageSeoConfig } from '#cutils/seo/buildContentPageSeoConfig';
import { buildSearchStructuredData } from '#cutils/seo/schema-org/buildSearchStructuredData';
import { envConfigServer } from '#sconfig/env.server';

type Props = InferGetServerSidePropsType<typeof getServerSideProps>;

const Page: NextPage<Props> = ({ schema, seoConfig }) => {
	return <Search schema={schema} seoConfig={seoConfig} />;
};

const SEO_TITLE = 'Suche';

const appUrl = `${envConfigServer.SELF_ORIGIN}${envConfigServer.BASE_URL}`;
const seoUrl = `${appUrl}/suche`;
const seoOptions = { title: SEO_TITLE, url: seoUrl };

const schema = buildSearchStructuredData({
	name: `${SEO_TITLE} | ${envConfigServer.APP_NAME}`,
	url: seoOptions.url,
});

const seoConfig = { ...buildContentPageSeoConfig(seoOptions), noindex: true };

export const getServerSideProps = createDefaultGetServerSideProps(() => {
	return {
		props: { navigationTitle: 'Suche', cacheTags: new Set<CacheTag>(), seoConfig, schema },
	};
});

export default Page;
